
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best-treatment/[...slug]",
      function () {
        return require("private-next-pages/best-treatment/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best-treatment/[...slug]"])
      });
    }
  